import React from 'react'
import { defineMessages, injectIntl } from 'react-intl'
import { Input, TextInput } from '../../Input'
import { required, minLength } from '../../../utils/validations'

const messages = defineMessages({
  label: {
    id: 'UsernameInput.Username',
    defaultMessage: 'Username',
    description: 'The label for the username text input.',
  },
})

export const UsernameInput = injectIntl(({ intl }) => {
  const { formatMessage } = intl
  const validate = (value) => {
    if (!value) return required(value, formatMessage)
    return minLength(value, 3, formatMessage)
  }

  return (
    <Input
      component={TextInput}
      name='username'
      id='username'
      autocomplete='username'
      label={formatMessage(messages.label)}
      placeholder={formatMessage(messages.label)}
      validate={validate}
      maxLength={56}
      required
    />
  )
})
